module.exports = __webpack_public_path__ + "static/img/Masterclass.b4ee9d01.jpg";